import * as React from 'react';
import {
	fileOptions,
	fileOption
} from './FileUploadField.style';
import FileField from './FileField';
import PropTypes from 'prop-types';

import { Box } from '@wds/box';
import { Modal } from '@wds/modal';
import { Button } from '@wds/button';
import { IconWarningFilled } from '@wds/icons';

import configuration from './configuration';

import './FileUploadField.scss';
export default class FileUploadField extends React.Component {
	constructor(props) {
		super(props);

		const enableDraftButton = () => {
			const draftButton = document.getElementsByClassName('sma-js-save-draft-btn');
			if (draftButton.length) {
				draftButton[0].disabled = false;
			}
		};

		const removeFileFromList = (index, filePath) => {
			let { nextIndex } = this.state;
			let fileList = this.state.fileList.filter((item) => {
				let keep = true;
				if (item.props.index === index) {
					keep = false;
				}
				return keep;
			});
			// If the last item has a file and we are below the max, then create a new file field
			const lastItem = fileList[fileList.length - 1];
			let createUploadButton = false;
			if (lastItem) {
				if (lastItem.props.hasFile) {
					createUploadButton = true;
				}
			} else {
				createUploadButton = true;
			}

			if (createUploadButton) {
				const newField = createNewFile(nextIndex);
				fileList.push(newField);
				nextIndex = nextIndex + 1;
			}

			if (fileList.length === 1) {
				fileList[0].props.first = true;
			}

			const deletedFiles = [
				...this.state.deletedFiles
			];
			if (filePath) {
				const id = `${this.props.id}_${index}-delete`;
				const deletionField = (
					<input
						type="hidden"
						key={index}
						name={id}
						id={id}
						value={filePath}
					/>
				);
				deletedFiles.push(deletionField);
			}
			notifyApply(this.props.id, fileList.length > 1)
			this.setState({
				fileList: fileList,
				deletedFiles: deletedFiles,
				nextIndex: nextIndex,
			});

			enableDraftButton();
		};

		const handleInputChange = (index, event) => {
			const { name, value } = event.target;
			let fieldName;
			if (name.indexOf('name') > -1) {
				fieldName = 'fileName';
			} else if (name.indexOf('description') > -1) {
				fieldName = 'fileDescription';
			} else {
				// Unknown field type;
			}

			// Add file info to the field where the file was added
			fileList.forEach((file) => {
				if (file.props.index === index) {
					file.props[fieldName] = value;
				}
			});
		};

		const createNewFile = (index, name, description, file, converted) => {
			let hasFile = false;
			if (file && file.length > 1) {
				hasFile = true;
			}
			const newField = new FileField({
				id: this.props.id,
				index: index,
				hasFile: hasFile,
				disabled: this.props.disabled,
				addFileToList: addFileToList,
				notifyApply: notifyApply,
				fileFormats: this.props.fileFormats,
				includeDescription: this.props.includeDescription,
				limitFileFormat: this.props.limitFileFormat,
				maxFileSize: this.props.maxFileSize,
				handleFileDelete: removeFileFromList,
				handleInputChange: handleInputChange,
				fileName: name,
				fileDescription: description,
				file: file,
				converted: converted,
				mediaUrl: this.props.mediaUrl,
			});
			return newField;
		};

		const notifyApply = (id, hasFile) => {
			window.uploadHasFile[id] = hasFile;
			window.fileUploadChanged(id);
		};

		const addFileToList = (index, name, size, type) => {
			let valid = true;
			const nameRegex = /([\w-\.\(\\) ]+)/g;
			// Validate that there is a file (Not all change events are new files selected)
			if (!name) {
				valid = false;
				this.setState({
					showErrorModal: true,
					errors: [
						gettext('A file name is required.')
					],
				});
			// Validate that the file is of accepted size
			// Size is bytes, convert to MB
			} else if ((size / 1000000) > this.props.maxFileSize) {
				valid = false;
				const errorMessage = `${gettext('The selected file size is too large.  Maximum file size is: ')}
					${this.props.maxFileSize}MB.`;
				this.setState({
					showErrorModal: true,
					errors: [
						errorMessage,
					],
				});
			// Validate if name contains invalid characters
			} else if (name.match(nameRegex)[0] != name) {
				valid = false;
				// To get the invalid characters replace the valid ones by an empty string
				const invalidCharacters = name.replace(nameRegex, '').split('');
				const errorMessage = `${gettext('We are unable to upload the selected file')} (${name}).` +
					`${gettext('The file name contains illegal characters: ')} ${invalidCharacters.join(', ')}`;
				this.setState({
					showErrorModal: true,
					errors: [
						errorMessage,
						gettext('Please rename the file and try again.'),
					],
				});
			}

			if (valid) {
				const fileList = [
					...this.state.fileList,
				];
				const { nextIndex } = this.state;

				if (this.allowMore(fileList.length)) {
					const newField = createNewFile(nextIndex);
					fileList.push(newField);
				}

				if (name) {
					// Add file info to the field where the file was added
					fileList.forEach((file) => {
						if (file.props.index === index) {
							file.props.fileName = name;
							file.props.fileSize = size;
							file.props.fileType = type;
							file.props.hasFile = true;
						}
					});
				}

				this.setState({
					fileList: fileList,
					nextIndex: this.state.nextIndex + 1,
				});
			}

			return valid;
		};

		let nextIndex = 0;
		const fileList = [];
		if (props.existing && Object.keys(props.existing).length > 0) {
			const existingValues = props.existing;
			const orderedValues = {};
			Object.keys(existingValues).sort().forEach((key) => {
				orderedValues[key] = existingValues[key];
			});
			Object.entries(orderedValues).forEach(([key, value]) => {
				const file = createNewFile(
					parseInt(key), value.name, value.description, value.file_url, value.converted_url
				);
				fileList.push(file);
			});
			// The next index is the last index in the list + 1
			nextIndex = fileList[fileList.length - 1].props.index + 1;
		}

		// Add button to add new file only if max files not already hit
		if (this.allowMore(fileList.length)) {
			const nextField = createNewFile(nextIndex);
			if (fileList.length === 0) {
				nextField.props.first = true;
			}
			fileList.push(nextField);
			nextIndex = nextIndex + 1;
		}
		this.state = {
			fileList: fileList,
			nextIndex: nextIndex,
			deletedFiles: [],
			errors: [],
			showErrorModal: false,
		};

		this.handleErrorModalClose = this.handleErrorModalClose.bind(this);
	}

	allowMore(listLength) {
		let allowMore = false;
		if (listLength === 0) {
			// Always allow at least 1 file
			allowMore = true;
		} else {
			if (this.props.allowMultiple) {
				if (this.props.limitUploads) {
					if (listLength < this.props.max) {
						// Limiting uploads, but have not reached the max number of files yet
						allowMore = true;
					}
				} else {
					// We are not limiting uploads
					allowMore = true;
				}
			}
		}
		return allowMore;
	}

	handleErrorModalClose() {
		this.setState({
			showErrorModal: false,
		});
	}

	render() {
		return (
			<>
				<Modal
					show={this.state.showErrorModal}
					onClose={this.handleErrorModalClose}
				>
					<Modal.Header header={gettext('Invalid File Selection')} />
					<Modal.Body>
						<Box display="grid" gridTemplateColumns="12% auto">
							<Box pt={1}>
								<IconWarningFilled color="warning" size="lg" />
							</Box>
							<Box>
								{
									this.state.errors.map((error) => {
										return (
											<p key={error}>
												{error}
											</p>
										);
									})
								}
							</Box>
						</Box>
					</Modal.Body>
					<Modal.Footer align="right">
						<Button onClick={this.handleErrorModalClose}>{gettext('OK')}</Button>
					</Modal.Footer>
				</Modal>
				<div className="upload-field">
					{
						((this.props.allowMultiple && this.props.limitUploads) || this.props.maxFileSize)
						&& (
							<div style={fileOptions}>
								{
									(this.props.allowMultiple && this.props.limitUploads)
									&& (
										<>
											{
												this.props.required
												&& (
													<div style={fileOption}>
														<strong>{gettext('Minimum')}:</strong> {this.props.min}
													</div>
												)
											}
											<div style={fileOption}>
												<strong>{gettext('Maximum')}:</strong> {this.props.max}
											</div>
										</>
									)
								}
								{
									this.props.maxFileSize
									&& parseInt(this.props.maxFileSize) !== parseInt(configuration.defaults.maxFileSize)
									&& (
										<div style={fileOption}>
											<strong>{gettext('Max file size')}:</strong> {this.props.maxFileSize} MB
										</div>
									)
								}
							</div>
						)
					}
					<ol>
						{
							(
								this.state.fileList && this.state.fileList.map((fileField) => {
									return fileField.render({
										disabled: this.props.disabled,
										fileFormats: this.props.fileFormats,
										includeDescription: this.props.includeDescription,
										limitFileFormat: this.props.limitFileFormat,
										maxFileSize: this.props.maxFileSize,
									});
								})
							)
						}
					</ol>
				</div>
				{
					(
						this.state.deletedFiles && this.state.deletedFiles.map((deletedFile) => {
							return deletedFile;
						})
					)
				}
			</>
		);
	}
}

FileUploadField.propTypes = {
	allowMultiple: PropTypes.bool.isRequired,
	fileFormats: PropTypes.string.isRequired,
	maxFileSize: PropTypes.number.isRequired,
	min: PropTypes.number.isRequired,
	disabled: PropTypes.bool.isRequired,
	includeDescription: PropTypes.bool.isRequired,
	limitFileFormat: PropTypes.bool.isRequired,
	limitUploads: PropTypes.bool,
	max: PropTypes.number,
	mediaUrl: PropTypes.string,
	required: PropTypes.bool.isRequired,
};

FileUploadField.defaultProps = {
	maxFileSize: 1000,
	min: 0,
	limitUploads: false,
	allowMultiple: true,
	fileFormats: '*',
};
